import { DASHBOARD_FOCUS } from "@lib/enums";

interface Recruiter {
  only_demo_float?: boolean;
  float_count?: number;
  user?: { first_name?: string };
}

export interface WelcomeContent {
  title: string;
  subtitle: string;
  button: string;
  badgeIcon: string;
  badgeText: string;
}

const recruiterLevel = (floatCount: number = 0): string => {
  switch (true) {
    case floatCount < 20:
      return "Level 1";
    case floatCount < 50:
      return "Level 2";
    case floatCount < 100:
      return "Level 3";
    case floatCount < 500:
      return "Level 4";
    default:
      return "Level 5";
  }
};

// The welcome panel follows the recruiter's dashboard focus setting, so the
// call to action creates whichever record type their stats are about.
const FOCUS_NOUNS = {
  [DASHBOARD_FOCUS.FLOATS]: "float",
  [DASHBOARD_FOCUS.SUBMISSIONS]: "submission",
} as const;

const content = (recruiter?: Recruiter, focus?: string): WelcomeContent => {
  const noun = FOCUS_NOUNS[focus as keyof typeof FOCUS_NOUNS] ?? "float";

  let title = "👋 Welcome to Floats!";
  let button = `Create your first ${noun}`;
  let badgeIcon = "🐥";
  let badgeText = "First timer!";
  let subtitle = `Looks like you're new here! To get started you can create your first ${noun} or just take a look around and discover our app!`;

  if (!recruiter?.only_demo_float) {
    // Determine user's local time of day
    const hour = new Date().getHours();
    let timeOfDay = "morning";
    if (hour >= 18 || hour < 5) {
      timeOfDay = "evening";
    } else if (hour >= 12) {
      timeOfDay = "afternoon";
    }

    title = `Good ${timeOfDay}, ${recruiter?.user?.first_name}!`;
    subtitle =
      "What do you want to do today? If you're not sure how to get started or what to do next you can always book a quick chat with us!";
    button = `Create a ${noun}`;

    badgeIcon = "🔥";
    badgeText = recruiterLevel(recruiter?.float_count);
  }
  return {
    title,
    subtitle,
    button,
    badgeIcon,
    badgeText,
  };
};

export default content;
